import { DeckDef } from "../types";

// Deck #3 — „Dla samorządów i administracji". Treść i sceny dedykowane (reuse ≤ 3/10).
export const municipalitiesDeck: DeckDef = {
  id: "municipalities",
  slug: "samorzady",
  title: "Dla samorządów i administracji",
  subtitle: "Wiarygodne głosowania i konsultacje dla mieszkańców",
  publisher: "Fundacja Potrafisz Polsko · lubbezposrednio.pl",
  estimatedMin: 14,
  ready: true,
  slides: [
    {
      id: "hero",
      tone: "brand",
      scene: "civic-hero",
      logo: "/LBP_Logo_White.svg",
      title: "Cyfrowe głosowania *dla Twojej gminy*",
      lead: "Budżet obywatelski, konsultacje i głosowania rady — online, z dowodem uczciwości.",
      durationSec: 40,
      notes:
        "Otwarcie pod samorząd. Jedno zdanie: dajemy gminie komplet narzędzi do głosowań i konsultacji, którym mieszkańcy zaufają. Ratusz + mieszkańcy na grafice budują kontekst lokalny."
    },
    {
      id: "problem",
      scene: "turnout-gauge",
      kicker: "Problem",
      title: "Niska frekwencja, *kruche zaufanie*",
      lead: "Papier jest drogi i wolny, a wynikom zwykłego e-głosowania mieszkańcy nie ufają.",
      bullets: [
        "Część mieszkańców nie dotrze do urny — wykluczenie czasowe i cyfrowe.",
        "Brak twardego dowodu, że nikt nie ruszył wyniku.",
        "Zakwestionowany wynik podważa decyzję rady albo urzędu."
      ],
      durationSec: 70,
      notes:
        "Wskaźnik frekwencji pokazuje realny ból: przy papierze idzie do urny garstka. Podkreśl, że problem to nie liczenie, tylko DOSTĘPNOŚĆ i ZAUFANIE do wyniku."
    },
    {
      id: "budget",
      scene: "participatory-budget",
      kicker: "Budżet obywatelski",
      title: "Mieszkańcy wybierają *projekty*",
      lead: "Głosowanie z telefonu, wyniki na żywo — i każdy może je potem niezależnie sprawdzić.",
      bullets: [
        "Prosty wybór projektów, progi poparcia i limity kwotowe.",
        "Wynik wraca do mieszkańców z dowodem, nie z samym komunikatem."
      ],
      durationSec: 65,
      notes:
        "Najbardziej znane zastosowanie. Pokaż, że cały proces budżetu obywatelskiego — od głosu po ogłoszenie zwycięskich projektów — jest wygodny i weryfikowalny."
    },
    {
      id: "consult",
      scene: "consultation",
      kicker: "Konsultacje społeczne",
      title: "Realny głos mieszkańców, *bez papieru*",
      lead: "Pytania otwarte i zamknięte, opinie w jednym miejscu, frekwencja jak nigdy.",
      bullets: [
        "Konsultacje uchwał, planów i inwestycji — dostępne całą dobę.",
        "Zbierasz mierzalny głos, nie stos kartek do przepisania."
      ],
      durationSec: 60,
      notes:
        "Konsultacje to codzienność urzędu. Tu wartość: realny, policzalny głos mieszkańców i koniec z papierową obsługą. Grafika: opinie spływające do wspólnej urny."
    },
    {
      id: "council",
      scene: "council-vote",
      kicker: "Głosowania rady",
      title: "Głosowania radnych — *szybko i jawnie*",
      lead: "Imienne lub tajne, z natychmiastowym i w pełni udokumentowanym wynikiem.",
      bullets: [
        "Wynik liczony automatycznie: za / przeciw / wstrzymujące.",
        "Niepodważalny zapis każdego głosowania rady."
      ],
      durationSec: 60,
      notes:
        "Drugie ciało odbiorcze: sama rada. Głosowania na sesji — jawne (imienne) lub tajne — z natychmiastowym wynikiem i trwałym protokołem. Tablica wyników na grafice."
    },
    {
      id: "access",
      scene: "device-trio",
      kicker: "Dostępność",
      title: "W kieszeni *każdego* mieszkańca",
      bullets: [
        "Web, iOS i Android — głos z telefonu, tabletu lub komputera.",
        "Udogodnienia dla osób z niepełnosprawnościami (WCAG).",
        "Panel urzędu: tworzysz głosowanie i śledzisz frekwencję na żywo."
      ],
      durationSec: 65,
      notes:
        "Frekwencja rośnie, gdy głosowanie jest pod ręką. Pokaż realny panel i aplikacje. Dostępność (WCAG) to dla administracji publicznej wymóg, nie dodatek."
    },
    {
      id: "verify",
      scene: "verify-lights",
      kicker: "Zaufanie i prywatność",
      title: "Sprawdzalny wynik, *tajny głos*",
      lead: "Jedno kliknięcie potwierdza, że wynik jest prawdziwy — a mimo to nie wiadomo, kto jak głosował.",
      bullets: [
        "Tajne głosowania: wiadomo, ŻE ktoś zagłosował, nie JAK.",
        "Zgodność z RODO; dane przetwarzane w Polsce i UE."
      ],
      terms: [
        { term: "ZKP", gloss: "dowód bez ujawniania głosu" },
        { term: "RODO", gloss: "unijna ochrona danych" }
      ],
      durationSec: 70,
      notes:
        "Połączenie dwóch rzeczy, które zwykle się wykluczają: pełna weryfikowalność wyniku i tajność głosu. To rozbraja zarówno zarzut o manipulację, jak i obawy o prywatność."
    },
    {
      id: "cost",
      scene: "cost-compare",
      kicker: "Koszty i wdrożenie",
      title: "Taniej niż papier, *bez serwerowni*",
      lead: "Druk, obsługa i ręczne liczenie znikają. Gmina nie stawia żadnej własnej infrastruktury.",
      bullets: [
        "My uruchamiamy i utrzymujemy całość; urząd dostaje gotowy panel.",
        "Rozwiązanie polskie, z polskim wsparciem."
      ],
      durationSec: 55,
      notes:
        "Zdejmij obawę o koszty i IT. Porównanie wprost: papier = druk, obsługa, czas; online = grosze za głos. Gmina nie potrzebuje serwerów ani zespołu IT."
    },
    {
      id: "cta",
      tone: "brand",
      scene: "launch",
      kicker: "Następny krok",
      title: "Zróbmy *pilotaż* w Państwa gminie",
      lead: "Jedno głosowanie lub konsultacja — pokażemy efekt na realnym przykładzie, przy niskim ryzyku.",
      cta: "kontakt@potrafiszpolsko.pl · lubbezposrednio.pl",
      durationSec: 40,
      notes:
        "Zamknięcie z konkretną, niskoryzykowną propozycją: pilotaż na jednym głosowaniu lub konsultacji. Zostaw kontakt na ekranie."
    }
  ]
};
